// extracted by mini-css-extract-plugin
module.exports = {"editTemplatesLink":"_36OoLm5eT-bwQ_UFEE9uZn","is-toggled":"_Z_oTscfIiQEUQEJ3kWD8"};